import { render, staticRenderFns } from "./JsonImporter.vue?vue&type=template&id=fa9ce908&scoped=true"
import script from "./JsonImporter.vue?vue&type=script&lang=js"
export * from "./JsonImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9ce908",
  null
  
)

export default component.exports